<template>
	<div class="container g-flex g-row-center">
		<div class="search-box g-font-14">
			<div class="g-p-3 g-flex">
				<!--  下拉菜单  -->
				<div class="dropdown-menu">
					<el-dropdown @command="selectMenu">
						<div class="drop-menu-title blue-text g-nowrap">
							{{dropdownMenu[menuIndex].name}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="index" v-for="(item,index) in dropdownMenu" :key="index">
								{{item.name}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<!--  输入框  -->
				<el-input v-model="keyword" placeholder="请输入内容进行搜索" @keyup.enter.native="doSearch"></el-input>
				<!--  搜索按钮  -->
				<div class="submit-btn g-nowrap" @click="doSearch">搜索</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		stripscript
	} from "@/utils/common.js";
	export default {
		name: "search-bar",
		data() {
			return {
				dropdownMenu: [{
						name: '搜课程',
						path: 'course-list'
					},
					{
						name: '搜职位',
						path: 'find-job'
					},
					// {
					// 	name: '搜人才',
					// 	path: 'find-careers'
					// },
					{
						name: '搜考试',
						path: 'examination'
					}
				], //菜单列表
				menuIndex: 1, //菜单下标
				keyword: ''
			}
		},
		props: {
			index: {
				type: Number,
				default: 1,
				required: false
			},
			value: {
				type: String,
				required: false
			},
      isCallback: {
				type: String,
				required: false
			}
		},
		computed: {
			getLoginState() {
				return this.$store.state.isLogin
			},
			getUserRole() {
				return this.$store.state.userInfo.role_name
			},
			isClinic() {
				return this.$store.state.isLogin && (this.$store.state.userInfo.clinicId != '' && this.$store.state
					.userInfo.clinic_id != -1)
			},
			isCustomer() {
				return this.$store.state.isLogin && (this.$store.state.userInfo.clinicId == '' || this.$store.state
					.userInfo.clinic_id == -1)
			},
			hideMenue() {
				return index => {
					if (index == 1) {
						return this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id != '' && this.$store
							.state.userInfo.clinic_id != -1)
					} else if (index == 2) {
						return !this.$store.state.isLogin || this.$store.state.isLogin && (this.$store.state.userInfo
							.clinic_id == '' || this.$store.state.userInfo.clinic_id == -1)
					} else {
						return false
					}
				};

			}
		},
		created() {
			this.keyword = this.value
			this.menuIndex = this.index
		},
		methods: {
			// 菜单选择
			selectMenu(e) {
				this.menuIndex = e
			},
			// 点击/回车的搜索事件
			doSearch() {
			  if(this.isCallback){
          this.$emit('doSearch', this.keyword)
        }else{
          let path = this.dropdownMenu[this.menuIndex].path;
          this.$router.push({
            path: path,
            query: {
              s: stripscript(this.keyword)
            }
          })
        }


			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		background: #E9F2FF;
		padding: 15px 0;

		.search-box {
			width: 860px;
			background: #ffffff;
			border-radius: 5px;
			box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);

			.dropdown-menu {
				padding: 10px 25px;
				background: #f7f8fc;
				border-radius: 5px;
				box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
				cursor: pointer;
			}
		}
	}

	::v-deep .el-input__inner {
		border: none !important;
		outline: none !important;
	}

	.submit-btn {
		padding: 11px 44px;
		margin-right: 0;
	}
</style>
